// Pathify
import { make } from 'vuex-pathify'

const endpoint = 'https://iz8od2e4pb.execute-api.us-east-2.amazonaws.com'
const setIsBusy = 'setIsBusy'

const state = {
  displayAsSingular: 'MaterialReport',
  displayAsPlural: 'MaterialReports',
  materialReports: {
    all: [],
    data: [],
    originalData: [],
    isBusy: false,
    isFirst: false,
    isLast: false,
    selected: [],
    setLast: false,
    empty: {
      part_id: null,
      order_quantity: null,
      unit: null,
      assemblyItemDescription: null,
      usageDescription: null,
      note: null,
      estimatorName: null,
      salespersonName: null,
      customerName: null,
      customerLocation: null,
    },
  },
}

const mutations = {
  ...make.mutations(state),

  setIsBusy: (state, isBusy) => {
    state.materialReports.isBusy = isBusy
  },

  push2Data: (state, dataFromDB) => {
    state.materialReports.data = []
    state.materialReports.data = dataFromDB

    // Get a copy of the original data, not a pointer to it
    state.materialReports.originalData = []
    for (const currentData of dataFromDB) {
      state.materialReports.originalData.push({ ...currentData })
    }

    state.materialReports.isBusy = false
  },
}

const actions = {
  ...make.actions(state),

  init: async () => {
    //
  },

  setEmpty: () => {
    state.materialReports.data = []
  },

  setDataFilteredOnDeliveryLoads: ({ rootState }) => {
    let filteredData = state.materialReports.originalData
    const selectedPlanLoads = rootState.deliveryload.deliveryloads.selectedPlanLoads
    let filterLoads = ''

    if (selectedPlanLoads) {
      if (selectedPlanLoads.length > 0) {
        filteredData = []
        for (const currentLoad of selectedPlanLoads) {
          filterLoads += currentLoad.load_id + ','
        }

        for (const currentData of state.materialReports.originalData) {
          if (filterLoads.includes(currentData.delivery_load_id)) {
            filteredData.push(currentData)
          }
        }
      }
    }

    state.materialReports.data = []
    state.materialReports.data = filteredData
  },

  retrieveAll: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'retrieveMaterial'
    commit(setIsBusy, true)

    const selectedCustomerId = (typeof rootState.customer.customers.selectedItem.client_id === 'undefined' ? null : rootState.customer.customers.selectedItem.client_id)
    const selectedPlanId = (typeof rootState.plan.plans.selectedItem.plan_id === 'undefined' ? null : rootState.plan.plans.selectedItem.plan_id)

    if (selectedCustomerId && selectedPlanId) {
      let filterLoads = null

      if (payload) {
        for (const [index, currentLoad] of payload.entries()) {
          if (index === 0) {
            filterLoads = currentLoad.load_id + ','
          } else {
            filterLoads = filterLoads + currentLoad.load_id + ','
          }
        }
        if (filterLoads !== null) {
          filterLoads = filterLoads.slice(0, -1)
        }
      }

      // TODO: Remove filterLoads from API and sproc, filter clientside for performance and reduced API calls
      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${selectedCustomerId}/${selectedPlanId}/${filterLoads}`

      const options = {
        method: 'get',
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          commit('push2Data', jsonResponse.data)
        })
        .then(() => {
          dispatch('setDataFilteredOnDeliveryLoads')
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    } else {
      commit(setIsBusy, false)
    }
  },
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
